"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileToolFieldView = exports.Styles = exports.CSS = void 0;
var theme_1 = require("../../../components/theme");
var i18n_1 = require("../../../i18n");
var mithril_1 = require("../../../mithril");
var field_info_1 = require("../../field.info/field.info");
exports.CSS = {
    file: 'c-FileTool__file',
    form: 'c-FileTool__form',
    container: 'c-FileTool__container',
    active: 'c-Filetool__active'
};
exports.Styles = (_a = {},
    _a[exports.CSS.file] = {
        display: 'none'
    },
    _a[exports.CSS.form] = {
        width: '100%',
        height: '100%'
    },
    _a[exports.CSS.container] = {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        border: '1px solid ' + theme_1.DefaultTheme.font.color.disabled,
        '&:hover': {
            border: '1px solid ' + theme_1.DefaultTheme.color.accent,
            cursor: 'pointer'
        }
    },
    _a[exports.CSS.active] = {
        border: '1px solid ' + theme_1.DefaultTheme.color.accent
    },
    _a);
(0, theme_1.addStyles)(exports.Styles);
exports.FileToolFieldView = {
    viewInline: function (field) {
        return field.displayValue;
    },
    hasDetail: function (field) {
        return !!field.displayValue;
    },
    viewDetail: function (field) {
        if (!exports.FileToolFieldView.hasDetail(field)) {
            return null;
        }
        var result = [];
        result.push(field_info_1.FieldInfo.viewStat(i18n_1.T.FIELD_FILE_TOOL_FILE_SIZE, formatBytes(field.stateValue.size)));
        Object.keys(field.stateValue.metadata).forEach(function (key) {
            result.push(field_info_1.FieldInfo.viewStat(key, field.stateValue.metadata[key]));
        });
        return mithril_1.m.fragment({}, result);
    },
    viewEdit: function (field, ctrl) {
        if (field.displayValue) {
            return (0, mithril_1.m)('div', [
                field.displayValue
            ]);
        }
        if (ctrl.fieldsInLoadingState.length > 0) {
            return (0, mithril_1.m)('form', { className: exports.CSS.form }, [
                (0, mithril_1.m)('div', {
                    className: exports.CSS.container,
                    disabled: true
                }, ['Drag file here or click to upload'])
            ]);
        }
        return (0, mithril_1.m)('form', { className: exports.CSS.form }, [
            (0, mithril_1.m)('input', { className: exports.CSS.file, type: 'file', id: field.id, onchange: function (e) { return ctrl.onFile(e, field); } }, ''),
            (0, mithril_1.m)('div', {
                id: "drag-area-".concat(field.id),
                className: exports.CSS.container,
                onclick: function (e) { return ctrl.openFileDialog(e, field); },
                ondragover: function (e) { return ctrl.onDragOver(e, field); },
                ondragleave: function (e) { return ctrl.onDragLeave(e, field); },
                ondragend: function (e) { return ctrl.onDragEnd(e, field); },
                ondrop: function (e) { return ctrl.update(e, field); }
            }, ['Drag file here or click to upload'])
        ]);
    },
    hasClear: function (field) {
        return !!field.displayValue;
    },
    hasFile: function (field) {
        return !!field.displayValue;
    }
};
function formatBytes(bytes, decimals) {
    if (decimals === void 0) { decimals = 2; }
    if (bytes === 0) {
        return '0 Bytes';
    }
    var k = 1024;
    var dm = decimals < 0 ? 0 : decimals;
    var sizes = ['Bytes', 'KB', 'MB'];
    var i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
//# sourceMappingURL=file.tool.field.view.js.map